import React, { useEffect, useContext, useState, component } from "react";
import { Card, CardBody, Row, Col, Container, FormGroup, Form, Input, Button, Spinner } from "reactstrap";
import RelatorioApuracaoDre from "./RelApuracaoDre";
import RelatorioPendenciaAcumulada from "./RelPendenciaAcumulada";
import RelLogAlteracaoDre from "./RelLogAlteracaoDre";

// api
import usuario_api from "api/usuario_api.js";

//utils
import { getSessionCookie } from 'utils/cookies';

export default function RelatoriosLista() {


  const list_relatorios = [
    {
      tipo: "GERAL",
      relatorios: [
        { codigo: "relPermissao", codigoPermissao: "relApuracaoDre", title: "Apuração DRE Mensal", description: "Relatório detalhado da apuração DRE - Pendencias Acumuladas", component: (<RelatorioApuracaoDre></RelatorioApuracaoDre>) },
        { codigo: "relPermissao", codigoPermissao: "relPendenciaAcumulada", title: "Pendências Acumuladas", description: "Relatório .csv - Apuração das Pendencias Acumuladas", component: (<RelatorioPendenciaAcumulada></RelatorioPendenciaAcumulada>) },
        { codigo: "relPermissao", codigoPermissao: "relLogAlteracaoDRE", title: "LOGS - Alterações DRE", description: "Logs de alterações Dre Mensal e Administrativo", component: (<RelLogAlteracaoDre></RelLogAlteracaoDre>) },
      ]
    }

  ];

  const [relatorio, set_relatorio] = useState(null);
  const [isDisable, set_isDisable] = useState(true);
  const [liberadoHQ, set_liberadoHQ] = useState(false);
  const [liberadoGE, set_liberadoGE] = useState(false);
  var session = getSessionCookie();

  const handleRelatorio = (item) => {
    set_relatorio(item.component);
  }

  //permissao de usuario

  useEffect(() => {
    usuario_api.getFuncionalidadeAcaoLiberada("DREAdministrativo", "Editar").then((result) => { set_isDisable(!result); });


    if (session.perfil == "Administrador" || session.perfil == "Canal" || session.perfil == "Regional")
      set_liberadoHQ(true);
    if (session.perfil == "Administrador" || session.perfil == "Grupo Econômico")
      set_liberadoGE(true);
  }, []);

  return (
    <>
      {relatorio == null &&
        <div className="content">
          {list_relatorios.map((m, key) => (
            <div key={key} className="mt-4">
              <div className="subTitulo" style={{ marginTop: '20px', marginBottom: '0px' }}>
                <h6>{m.tipo}</h6>
              </div>
              <Container>
                <Row className="mb-4 align-items-end">
                  {m.relatorios.map((n, key2) => (
                    <Col key={key2} lg="4" md="6" sm="12">
                      <Card>
                        <CardBody className="rel-card-body">
                          <h5><strong>{n.title}</strong></h5>
                          {n.description}
                        </CardBody>
                        <row className="text-center">
                          <Button color="info" onClick={() => handleRelatorio(n)} className="btn-mobile">Visualizar Relatório</Button>
                        </row>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </Container>
            </div>
          ))}
        </div>
      }

      {
        relatorio != null &&
        <>
          {relatorio}
          <Row>
            <Col lg="12" md="12" sm="12" className="text-center">
              <Button color="link" onClick={() => set_relatorio(null)}>Voltar</Button>

            </Col>
          </Row>
        </>
      }
    </>
  );
}
